export default __webpack_public_path__ + "static/media/Scholarship.518d4913.png";